import React from "react";
import { NavLink } from "react-router-dom";
import { Typography } from "@mui/material";

const LinkList = ({ page, textColor }) => {
  return (
    <NavLink
      to={page.path}
      style={{
        textDecoration: "none",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: textColor,
          marginLeft: { xs: "0", md: "0.5rem" },
          textTransform: { xs: "capitalize", md: "uppercase" },
          fontSize: "10px",
          fontWeight: "bold",
        }}
        component="h6"
      >
        {page.title}
      </Typography>
    </NavLink>
  );
};

export default LinkList;
